<div fxLayout="row" fxLayoutAlign="center center" class="no-video-found">
    <div>
        No Video Found
    </div>
</div>
